export const COMPANY_PROFILE_CREATION_URL = '/pages/new/company';
export const BRANDMANAGER_URL = '/brandmanager';
